import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { Form, Row, Col, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import LoaderButton from "../components/LoaderButton";

import "react-datepicker/dist/react-datepicker.css";

function VideoLinksEditForm(props) {
  const { isAuthenticated } = useAppContext();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [description, setDescription] = useState("");
  const [youtubeURL, setYouTubeURL] = useState("");
  const [expiryHours, setExpiryHours] = useState("168");
  const [isCreateForm, setIsCreateForm] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    async function onLoad() {
      if (!isAuthenticated) {
        return;
      }
      setIsLoading(true);
      setIsCreateForm(true);
      let videoLink = queryString.parse(window.location.search);
      if (videoLink.premiereTime) {
        setIsCreateForm(false);
        setDescription(videoLink.description);
        setYouTubeURL(videoLink.youtubeUrl);
        setStartDate(new Date(videoLink.premiereTime));
      }
      setIsLoading(false);
    }

    onLoad();
  }, [isAuthenticated]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    let videoDetails = {
      body: {
        description: description,
        premiereTime: moment(startDate).utcOffset(10).format(),
        youtubeUrl: youtubeURL,
        expiryHours: expiryHours,
      },
    };
    let newItem = await postVideoDetails(videoDetails);
    history.push("/videoLinks");
  };

  const postVideoDetails = async (videoDetails) => {
    return API.post("api", "/videoLink", videoDetails);
  };

  return (
    <div className="container">
      <h3 className="mt-5 mb-5">
        {isCreateForm ? "Create" : "Edit"} Video Link
      </h3>
      {isLoading ? (
        "Loading..."
      ) : (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId="formVideoLinkDescription">
            <Form.Label column sm={2}>
              Video Link Title
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                required
                type="text"
                value={description}
                placeholder="Write a short title e.g. Entering the Middle Way"
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
              <Form.Control.Feedback type="invalid">
                Please choose a title.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formVideoLinkYoutubeURL">
            <Form.Label column sm={2}>
              YouTube URL
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                value={youtubeURL}
                placeholder="Copy the YouTube URL into here. Leave blank if not yet known"
                onChange={(e) => {
                  setYouTubeURL(e.target.value);
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formVideoLinkDateTime">
            <Form.Label column sm={2}>
              Video Start Time
            </Form.Label>
            <Col sm={10}>
              <DatePicker
                selected={startDate}
                disabled={!isCreateForm}
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={30}
                timeCaption="time"
                dateFormat="dd/MM/yyyy h:mm aa"
                className="form-control"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formVideoLinkExpiryHours">
            <Form.Label column sm={2}>
              Hours until Expiry
            </Form.Label>
            <Col sm={10}>
              <Form.Control disabled type="text" defaultValue="168" />
              <Form.Control.Feedback type="invalid">
                Please choose a title.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <LoaderButton variant="success" type="submit" isLoading={isLoading}>
            {isCreateForm ? "Create" : "Edit"} Video Link
          </LoaderButton>{" "}
          <LinkContainer to="/videoLinks">
            <Button variant="primary">Cancel</Button>
          </LinkContainer>
        </Form>
      )}
    </div>
  );
}

export default VideoLinksEditForm;
